import { appStore } from "@app/store/store"
import { Navigate, Outlet } from "react-router"

export default function ProtectedRoute({ children, path }) {
	if (!appStore.get("core.relation")) {
		return <Navigate to={"/login" + (path ? "?forwardTo=" + path : "")} replace />
	}

	return <>{children ? children : <Outlet />}</>
}
